
export const notify = {
    noComp: "General Input Validation: Please select a composition.",
    noLayer: "General Input Validation: Please select a layer.",
    noKeyframes: "Property with 0 selected keyframes found.",
    insufficientLayers: "Please select 2 or more layers.",
    pleaseAddOneOrMoreKeyframes: "Please add one or more keyframes to the selected property.",
    pleaseSelectOneOrMoreKeyframes: "Please select one or more keyframes across two or more layers or properties.",
    elasticNoDelta: "Penultimate and final keyframe share static values.",
    maskPath: "Mask paths are not yet supported."
}